import classNames from "classnames";
import { useNavigate } from 'react-router-dom'


function CategoryOption ({to, editTo, category, children, className, activeClassName, handleOptionSelection, selected}){
    const navigate = useNavigate();
    const classes = classNames(
        'text-black', 
        className,
        selected === to && activeClassName
    );

    const handleClick = (event) => {
        if(event.metaKey || event.ctrlKey) return;
        event.preventDefault();
        handleOptionSelection(to)
        navigate(to)
    }
    return (
        <div className="flex flex-row mt-4 text-lg">
            <div className="col-start-1">
                <span style={{ backgroundColor: `${category.color}`,color: `${category.color}` }}
                className='rounded-r-full mr-2'>+</span>
            </div>
            
            <div className="col-start-2">
                <a className={classes} href={to} onClick={handleClick}>{category.name}</a>
            </div>
            
            <div className="font-bold text-l text-gray-400 text-right ml-2">(#{category.projectsCount})</div>
        </div>
    )
}

export default CategoryOption